var angular = require('angular');
var _module = require('./index');

_module.directive('modalPane', [function() {
    return {
        restrict: 'E',
        templateUrl: 'js/components/modals/templates/modal-pane.tmpl.html',
        transclude: true,
        scope: {
            title: '=',
            headerColor: '='
        },
        bindToController: true,
        controllerAs: 'vm',
        controller: [
            function() {
                var vm = this;
                init();

                function init() {
                }

            }
        ]
    };
}]);
